module.exports = __webpack_public_path__ + "static/media/greg-correct.bcc60cda.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/trueBridge/greg-correct.png
// module id = 3529
// module chunks = 0